import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ClientService } from '../../services/accountmanagement/client.service';
import { Observable } from 'rxjs';
import { User } from '../../core/auth';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../core/reducers';
import { currentUser } from '../../core/auth';
import moment from 'moment';
import { selectAuthState } from '../../core/auth/_selectors/auth.selectors';
import { LogDto } from '../../models/dto/log.dto';
import { Action } from '../../models/enums/action.enum';
import { LogService } from '../../services/log/log.service';
import { Screen } from '../../models/enums/screen.enum';
import * as jwt_decode from "jwt-decode";
import { DomSanitizer, Title } from '@angular/platform-browser';
import { PowerBILogService } from '../../services/log/powerBILog.service';
import { TransferrequestService } from '../../services/transferrequest/transferrequest.service'
import { count } from 'console';
import { element } from 'protractor';

declare var $: any;
@Component({
  selector: 'kt-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.scss']
})
export class MyProfileComponent implements OnInit {
  @ViewChild('directionModal', { static: true }) directionModal: TemplateRef<any>;
  @ViewChild('companyModal', { static: true }) companyModal: TemplateRef<any>;
  @ViewChild('successModal', { static: true }) successModal: TemplateRef<any>;
  @ViewChild('empresaSuccess', { static: true }) empresaSuccess: TemplateRef<any>
  @ViewChild('directionSuccess', { static: true }) directionSuccess: TemplateRef<any>
  @ViewChild('updateSuccess', { static: true }) updateSuccess: TemplateRef<any>
  @ViewChild('userError', { static: true }) userError: TemplateRef<any>
  user$: Observable<User>;
  userForm: FormGroup;
  directionForm: FormGroup;
  companyForm: FormGroup;
  required: boolean = false;
  selDirPais = "Dominican Republic";
  selectedEmpresaPais = "Dominican Republic";
  selectedPais = 'Dominican Republic';
  selectedTitle = "Sr.";
  selectedRol = "Seleccionar.";
  paisFlag: boolean = true;
  RolEmpresa: any;
  address: any;
  public checkValidation: boolean = false;
  public checkDirection: boolean = false;
  public checkCompany: boolean = false;
  public currentStep = 0;
  public currentUserStep = 0;
  public responseList: any = [];
  public userList: any = [];
  public countryList: any = [];
  public companyList: any = [];
  public addressList: any = [];
  public userId: any;
  public clientId: any;
  public rnc: boolean = false;
  birhdate;
  public companyCode = '';
  public companyName;
  email = '';
  fullname = '';
  selectedCompany;
  companyRole: any;
  public url;
  public imagePath;
  imgURL: any;
  viewImage: any;
  viewImageSrc: any;
  public message: string;
  public fileName: any;
  public files;
  public dateTime;
  public payload$: Observable<any>;
  assignedcompany: any = [];
  public module: any;
  public objectType: any;
  public objectName: any;
  public clickEvent: any;
  public action: any;
  public screenId: any;
  public refNumber: any;
  public idAuth0: any;


  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private clientService: ClientService,
    private cd: ChangeDetectorRef,
    private store: Store<AppState>,
    private logService: LogService,
    private sanitizer: DomSanitizer,
    private powerBIService: PowerBILogService,
    private transferRequestService: TransferrequestService,
  ) { $('body').tooltip({ selector: '[data-toggle=tooltip]' }); }

  ngOnInit() {
    this.payload$ = this.store.pipe(select(selectAuthState));
    this.user$ = this.store.pipe(select(currentUser));
    this.user$.subscribe((user) => {
      this.email = user.email;
      this.fullname = user.fullname;
    })
    this.selectedCompany = JSON.parse(localStorage.getItem('Selectedcompany'));

    this.generateUserForm();
    this.getUserProfile();
    this.getUserAddress();
    this.getUserCompanies();
    this.getCountries();
    this.generateDirectionForm();
    this.generateCompanyForm();

    this.screenId = Screen.MiPerfil;
    this.module = "MiPerfil";
    this.clickEvent = "Click";
    this.action = "Redirect";
    this.objectType = "Button";
    this.objectName = "Mi Perfil";
    this.integrateAuditApi();
  }

  integrateAuditApi() {
    this.powerBIService.createPayload(this.screenId, this.module, this.clickEvent, this.action, this.objectType, this.objectName, this.refNumber, null, null);
  }

  generateUserForm(){
    this.userForm = this.fb.group({
      title:['', Validators.required],
      name:['', Validators.required],
      lastName:['', Validators.required],
      birthDate:['', Validators.required],
      email:['', Validators.required],
      cellPhone:['', Validators.required],
      country:['', Validators.required],
    })
  }

  getUserProfile() {
    this.transferRequestService.getClientCode().subscribe((data) => {
      this.clientId = data.IdAuth0;
      this.userList = [];
      this.clientService.getUserProfile(this.clientId).subscribe((response: any) => {
        this.userList = response;
        this.getTitle(this.userList.title);
        this.userForm.controls.name.setValue(this.userList.name);
        this.userForm.controls.lastName.setValue(this.userList.lastName);
        this.userForm.controls.birthDate.setValue(this.userList.birthDate);
        this.userForm.controls.email.setValue(this.userList.email_User);
        this.userForm.controls.cellPhone.setValue(this.userList.cellPhone);
        this.viewImageSrc = '../../../assets/img/avatar.png';
      });
    });
  }

  private getTitle(id) {
    if(id = '99B68D18-DB2A-4A1E-8D87-8CA4910D05CD'){
       this.userForm.controls.title.setValue('Sr.'); 
    }
    else if(id = '01BA37B6-B14A-490E-9F35-26358444D180'){
      this.userForm.controls.title.setValue('Sra.')
    }
    else {
      this.userForm.controls.title.setValue('Srta.')
    }
  }

  preview(files) {
    this.viewImage = document.getElementById('imageIcon') as HTMLInputElement;
    if(files.length === 0)
      return;
    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.toastr.error('Solo se admiten imágenes.');
      return;
    }
    else {
      this.message = "";
      var reader = new FileReader();
      this.imagePath = files;
      reader.readAsDataURL(files[0]);
      reader.onload = (_event) => {
        this.imgURL = reader.result;
        this.viewImage.src = this.imgURL;
      }
      this.fileName = files[0].name;
      this.files = files[0];
    }
    this.cd.detectChanges();
  }

  //Funcion para guardar datos de la informacion general
  saveUserProfile(){
    this.clickEvent = "Click";
    this.action = "Save";
    this.objectType = "Button";
    this.objectName = "Guardar";
    this.integrateAuditApi();
    this.message = "";
    this.currentUserStep = 0;
    this.currentUserStep++;
    if (this.currentUserStep == 1 && this.userForm.invalid) {
      this.checkValidation = true
      this.currentUserStep--;
      this.toastr.info('Favor llenar todos los campos requeridos.', 'warning');
      return;
    } else {
      this.saveUserData();
      this.checkValidation = false;
    }
  }

  saveUserData(){
    let payload = new FormData();
  }

  //Funcion para abrir el modal de Direccion
  openDirectionModal(){
    this.clickEvent = "Click";
    this.action = "Open";
    this.objectType = "Button";
    this.objectName = "Agregar Direcciones";
    this.integrateAuditApi();

    if(this.userList){
      this.currentStep = 0;
      this.directionForm.reset();
      this.directionForm.controls.PaisDirection.setValue("Dominican Republic");
      this.modalService.open(this.directionModal, {
        size:'lg', backdrop: 'static'
      });
    }
    else{
      this.toastr.info('Por favor, actualice su perfil primero');
    }
  }

  generateDirectionForm(){
    this.directionForm = this.fb.group({
      DirTitle: ['', Validators.required],
      PaisDirection: ['', Validators.required],
      Estado: ['', Validators.required],
      Ciudad: ['', Validators.required],
      Cpostal: ['', Validators.required],
      Direccion: ['', Validators.required],
    });
  }

  generateCompanyForm(){
    this.companyForm = this.fb.group({
      Empresa: ['', Validators.required],
      PaisEmpresa: ['', Validators.required],
      RNC: ['', Validators.required],
      RolEmpresa: [''],
    });
  }

  saveDirectionData(){
    if(this.address) {
      let payload = {
        Id: this.address.Id,
        Title: this.directionForm.value.DirTitle,
        Country: this.directionForm.value.PaisDirection,
        Condition: this.directionForm.value.Estado,
        Town: this.directionForm.value.Ciudad,
        PostalCode: this.directionForm.value.Cpostal,
        Direction: this.directionForm.value.Direccion,
      }
      this.clientService.updateAddress(payload).subscribe(response => {
        this.modalService.dismissAll();
        this.updateSuccessModal();
        this.getUserAddress();
      },
      (error) => {
        this.modalService.dismissAll();
        this.toastr.error('Ha ocurrido un error, favor intente de nuevo. Si el error persiste , comunicarse al correo mardomgo@mardom.com');
      })
    }
    else {
      let payload = {
        Title: this.directionForm.value.DirTitle,
        Country: this.directionForm.value.PaisDirection,
        Condition: this.directionForm.value.Estado,
        Town: this.directionForm.value.Ciudad,
        PostalCode: this.directionForm.value.Cpostal,
        Direction: this.directionForm.value.Direccion,
      }
      this.clientService.addAddress(payload).subscribe(response => {
        this.modalService.dismissAll();
        this.directionSuccessModal();
        this.getUserAddress();
      }, 
      (error) => {
        this.modalService.dismissAll();
        this.toastr.error('Ha ocurrido un error, favor intente de nuevo. Si el error persiste , comunicarse al correo mardomgo@mardom.com');
      })
    }
    this.address = '';
  }

  updateSuccessModal(){
    this.modalService.open(this.updateSuccess, {
      size: 'sm', backdrop: 'static', centered: true
    });
  }

  getUserAddress(){
    this.clientService.getUserAddress().subscribe(response => {
      this.addressList = response;
      response = this.addressList.reverse();
      this.addressList = response;
      this.cd.detectChanges();
    });
  }

  directionSuccessModal(){
    this.modalService.open(this.updateSuccess, {
      size: 'sm', backdrop: 'static', centered: true
    });
  }

  patchAddressData(address) {
    this.directionForm.controls.DirTitle.setValue(address.Title);
    this.directionForm.controls.PaisDirection.setValue(address.Country);
    this.selDirPais = address.Country;
    this.directionForm.controls.Estado.setValue(address.Condition);
    this.directionForm.controls.Ciudad.setValue(address.Town);
    this.directionForm.controls.Cpostal.setValue(address.PostalCode);
    this.directionForm.controls.Direccion.setValue(address.Direction)
    this.cd.detectChanges();
  }

  onPaisSelected(name) {
    this.selDirPais = name;
  }

  getCountries(){
    this.clientService.getCountry().subscribe((response:any) => {
      const List = response.map((data) => {
        return { id: data.Id, text: data.name, ...data }
      });
      this.countryList = List;
      let index = this.countryList.findIndex(item => item.name == "Dominican Republic")
      if(index >= 0) {
        this.countryList.splice(index, 0);
      }
      this.sortByProp()
      this.cd.detectChanges();
    })
  }

  sortByProp() {
    this.countryList = this.countryList.sort(this.getSortOrder1());
  }

  getSortOrder1() {
    let prop = 'name';
    return function (a, b) {
      if (a[prop] > b[prop]) {
        return 1;
      }
      else if (a[prop] < b[prop]) {
        return -1;
      }
      return 0;
    }
  }

  editAddress(address:any) {
    this.address = address;
    this.openDirectionModal();
    this.patchAddressData(address);
  }

  deleteAddress(id) {
    this.clientService.deleteAddress(id).subscribe(data => {
      this.toastr.success("Direccion eliminada con éxito")
      this.getUserAddress();
    }, (error) => {
      this.toastr.error('Ha ocurrido un error, favor intente de nuevo.');
    })
  }

  closeModalDirection(){
    this.modalService.dismissAll();
  }

  guardar(){
    this.clickEvent = "Click";
    this.action = "Save";
    this.objectType = "Button";
    this.objectName = "Guardar";
    this.integrateAuditApi();

    this.currentStep++;
    if(this.currentStep == 1 && this.directionForm.invalid) {
      this.checkDirection = true
      this.currentStep--;
      this.toastr.info('Favor llenar todos los campos requeridos.', 'warning');
      return;
    }
    else {
      this.saveDirectionData();
      this.checkDirection = false;
    }
  }

  //Funcion para traer las empresas asociadas
  getUserCompanies(){
    this.clientService.getAssignCompany().subscribe(response => {
      this.assignedcompany = response;
      this.assignedcompany.forEach(element => {
        let index = this.responseList.findIndex(item => item.RNC == element.rnc)
        if (index >= 0) {
          this.responseList.splice(index,1);
        }
      });
      this.cd.detectChanges();
    })
  }

  openCompanyModal(){
    this.clickEvent = "Click";
    this.action = "Open";
    this.objectType = "Button";
    this.objectName = "Asociar Empresa";
    this.integrateAuditApi();
    if (this.userList) {
      this.rnc = false;
      this.currentStep = 0;
      //this.companyForm.reset();
      this.paisFlag = true;
      this.selectedEmpresaPais = "Dominican Republic";
      this.modalService.open(this.companyModal, {
        size: 'lg', backdrop: 'static'
      });
    } else {
      this.toastr.info('Por favor, actualice su perfil primero');
    } 
  }

  saveCompany(){
    this.currentStep++;
    if(this.currentStep == 1 && this.companyForm.invalid){
      this.checkCompany = true;
      this.currentStep--;
      this.toastr.info('Favor llenar todos los campos requeridos.', 'warning')
      return;
    }
    else {
      this.saveCompanyData();
      this.checkCompany = false;
    }
  }

  saveCompanyData(){
    let payload = {
      Country: this.companyForm.value.PaisEmpresa,
      RNC: this.companyForm.value.RNC,
      companyCode: this.companyCode,
      UserRole: this.RolEmpresa,
      Company: this.companyForm.value.Empresa,
      Status: "Solicitado"
    }
    this.clickEvent = "Click";
    this.action = "Save";
    this.objectType = "Button";
    this.objectName = "Guardar";
    this.clientService.addCompany(payload).subscribe(response => {
      this.modalService.dismissAll();
      this.getCompanies();
      this.empresaSuccessModal();
      this.sendMailToCompanyUser(payload);
      this.integrateAuditApi();
    }, 
    (error) => {
      this.modalService.dismissAll();
      this.toastr.error('Ha ocurrido un error, favor intente de nuevo. Si el error persiste , comunicarse al correo mardomgo@mardom.com');
    })
  }

  getCompanies(){
    this.clientService.getUserCompany().subscribe(response => {
      this.responseList = response;
      response = this.responseList.reverse();
      this.responseList = response;
      this.getUserCompanies();
      this.cd.detectChanges();
    })
  }

  empresaSuccessModal() {
    this.modalService.open(this.empresaSuccess, {
      size: 'sm', backdrop: 'static', centered: true
    });
  }

  sendMailToCompanyUser(Companydata) {
    let payload = {
      "useremailId": this.email,
      "adminemail": '',
      "role": Companydata.UserRole,
      "company": Companydata.Company,
      "UserName": this.fullname
    }
    this.clientService.sendMailToCompanyUser(payload).subscribe((response) => {
    }, 
    (error) => {
      this.toastr.error('Ha ocurrido un error, favor intente de nuevo.');
    })
  }

  selectedEmpresaCountry(name) {
    this.selectedEmpresaPais = name;
    const input = <HTMLInputElement>document.getElementById('empresa');
    if(this.selectedEmpresaPais == '26b5c993-bf78-4216-8eb5-4e377c6665ef' || this.selectedEmpresaPais == 'Dominican Republic') {
      this.paisFlag = true;
      input.disabled = true;
      this.companyForm.controls.Empresa.setValue('')
      this.companyForm.controls.RNC.setValue('')
    }
    else {
      this.paisFlag = false;
      input.disabled = false;
      this.companyForm.controls.Empresa.setValue('')
      this.companyForm.controls.RNC.setValue('')
      this.companyCode = '';
    }
  }

  cerrar() {
    this.modalService.dismissAll();
  }

  clearValue(rnc) {
    if (rnc && rnc.length == 0) {
      this.companyForm.controls.Empresa.setValue('');
    }
  }

  getSearchCompanies(rnc){
    this.clickEvent = "Click";
    this.action = "Search";
    this.objectType = "Search Category";
    this.objectName = "Buscar";
    this.refNumber = rnc;
    this.integrateAuditApi();
    this.rnc = false;

    if(rnc.length == 0) {
      this.companyForm.controls.Empresa.setValue('');
    }
    else if(rnc.length >= 3) {
      this.clientService.getCompanySearch(rnc).subscribe((data) => {
        this.companyList = data;
        if(this.companyList.length > 0) {
          this.rnc = true;
        }
        else if (this.companyList.length === 0) {
          this.companyForm.controls.Empresa.setValue('');
        }
      },
      (error) => {
        this.rnc = false;
        this.companyForm.controls.RNC.setValue('');
        this.companyForm.controls.Empresa.setValue('');
      });
      this.cd.detectChanges();
    }
  }

  onClick(company:any){
    this.rnc = false;
    this.companyForm.controls.Empresa.setValue(company.name)
    this.companyCode = company.id;
    this.companyForm.controls.RNC.setValue(company.rnc);
  }

  onSelectedValue(selected) {
    this.RolEmpresa = selected.value
  }
}